import React from 'react';

const Textarea = ({ id, name, className, label, value, onChange, placeholder, required, readOnly, errorText }) => {
  return (
    <div className='mb-10 form-block'>
      {label && (
        <label htmlFor={id} className='fw-700 mb-6'>
          {label}
        </label>
      )}
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
        className={`form-control ${errorText ? 'is-invalid' : ''} ${className || ''}`}
      />
      <div className='invalid-feedback mt-5'>{errorText}</div>
    </div>
  );
};

Textarea.defaultProps = {
  value: '',
  onChange: () => {},
};

export default Textarea;
